import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BranchesCoreService } from './branches-core.service';
import { BranchesSelectorComponent } from './branches-selector/branches-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [BranchesSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [BranchesCoreService],
  exports: [BranchesSelectorComponent],
})
export class BranchesCoreModule {}
